import React from 'react';

import ContactRefreshSubscriber from './controls/contact-refresh';
import DiarySubscriber from './controls/diary';
import GroupSubscriber from './controls/groups';

class Subscriber extends React.Component<any> {
  render() {
    return (
      <>
        <ContactRefreshSubscriber />
        <GroupSubscriber />
        <DiarySubscriber />
        {this.props.children}
      </>
    );
  }
}

export default Subscriber;
